/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class ProductTransactionTransformer extends Transformer {

  static fetch(transaction) {
    return {
      id: transaction.id,
      transactionId: transaction.transaction_id,
      code: transaction.code,
      via: transaction.via,
      qty: transaction.qty,
      status: transaction.status,
      createdAt: transaction.created_at,
      warehouse: transaction.warehouse,
      billingNumber: transaction.billing_number,
      client: transaction.client,
    };
  }

  static send(transaction) {
    return {
      id: transaction.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productTransaction.js